export default "__VITE_ASSET__HyCtmSmV__"